import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { theme } from '@openx/components-core/lib/theme/theme.ts';

interface FunnelTableProps {
  tableTitle: string;
  children: React.ReactNode;
}

const styles: { [key: string]: SxProps<Theme> } = {
  table: {
    backgroundColor: theme => theme.palette.background.paper,
    border: theme => `1px solid ${theme.palette.divider}`,
    paddingX: theme => theme.spacing(3),
    paddingY: theme => theme.spacing(2),
    width: '100%',
  },
};

export const FunnelTable = ({ children, tableTitle }: FunnelTableProps) => {
  return (
    <Box sx={styles.table} data-test="funnel-table">
      <Typography variant="h3">{tableTitle}</Typography>
      <Divider sx={{ marginY: theme.spacing(1) }} />
      {children}
    </Box>
  );
};
